import { styled } from 'baseui';

export default styled('div', ({ $theme, $isActive = true }) => {
  return {
    marginBottom: '8px',
  };
});
